/// <reference path="Player.ts"/>

import { PlayersManager } from "./PlayersManager";
import { Player } from "./Player";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { AudioManager } from "../../AudioManager";

export class ForwardPlayer extends Player {

    private static forwardRotatingTweenData: { rotation: number }[] = null;

    private returnToNullDegreesTween: Phaser.Tween;
    private preparedToShoot: boolean;
    private i: number;

    constructor(game: Phaser.Game, x: number, y: number, rightPlayer: boolean, playersManager: PlayersManager, movementType: string) {

        super(game, x, y, "" + GameVars.playerID, rightPlayer, movementType);

        const aiming_frame_ID = (GameVars.playerID - 1) * 5 + 1;
        const idle_frame_ID = (GameVars.playerID - 1) * 5 + 2;
        const selected_frame_ID = (GameVars.playerID - 1) * 5 + 3;
        const idle_blink_frame_ID = (GameVars.playerID - 1) * 5 + 4;
        const shooting_frame_ID = (GameVars.playerID - 1) * 5 + 5;

        this.textureAiming = "delantero_" + GameVars.formatNumberForTextureAtlas(aiming_frame_ID);
        this.textureIdle = "delantero_" + GameVars.formatNumberForTextureAtlas(idle_frame_ID);
        this.textureSelected = "delantero_" + GameVars.formatNumberForTextureAtlas(selected_frame_ID);
        this.textureIdleBlink = "delantero_" + GameVars.formatNumberForTextureAtlas(idle_blink_frame_ID);
        this.textureShooting = "delantero_" + GameVars.formatNumberForTextureAtlas(shooting_frame_ID);

        this.shootBall_px = 0;
        this.shootBall_py = 65;

        this.playersManager = playersManager;

        this.frameName = this.textureIdle;

        this.name = GameConstants.FORWARD_PEG;

        this.preparedToShoot = false;
        this.i = 0;

        if (ForwardPlayer.forwardRotatingTweenData === null) {

            this.rotation = 0;

            let tween1 = this.game.add.tween(this)
                .to({ rotation: 55 * Math.PI / 180 }, 325, Phaser.Easing.Quadratic.Out);

            let dataTween1 = tween1.generateData();

            this.rotation = 55 * Math.PI / 180;

            let tween2 = this.game.add.tween(this)
                .to({ rotation: 0 }, 325, Phaser.Easing.Quadratic.In);

            let dataTween2 = tween2.generateData();

            this.rotation = 0;

            let tween3 = this.game.add.tween(this)
                .to({ rotation: -55 * Math.PI / 180 }, 325, Phaser.Easing.Quadratic.Out);

            let dataTween3 = tween3.generateData();

            this.rotation = -55 * Math.PI / 180;

            let tween4 = this.game.add.tween(this)
                .to({ rotation: 0 }, 325, Phaser.Easing.Quadratic.In);

            let dataTween4 = tween4.generateData();

            this.rotation = 0;

            ForwardPlayer.forwardRotatingTweenData = dataTween1.concat(dataTween2, dataTween3, dataTween4);
        }
    }

    public update(): void {

        super.update();

        if (GameVars.paused) {
            return;
        }

        if (this.preparedToShoot) {

            const forwardRotatingTweenData = ForwardPlayer.forwardRotatingTweenData;
            this.body.rotation = forwardRotatingTweenData[this.i].rotation;

            this.i = this.i < forwardRotatingTweenData.length - 1 ? this.i + 1 : 0;
        }
    }

    public prepareToShoot(): void {

        super.prepareToShoot();

        if (this.returnToNullDegreesTween) {
            this.returnToNullDegreesTween.pendingDelete = true;
            this.body.rotation = 0;
        }

        this.preparedToShoot = true;

        if (!GameVars.penalties) {
            AudioManager.getInstance().playEffect("rebote_bumper");
        }
    }

    public shootBall(): void {

        this.preparedToShoot = false;

        super.shootBall();
    }

    public returnToIdle(): void {

        super.returnToIdle();

        this.returnToNullDegreesTween = this.game.add.tween(this.body)
            .to({ rotation: 0 }, 800, Phaser.Easing.Quadratic.Out, true);
    }

    public getShootAngle(): number {

        return this.angle + 90;
    }
}
